import React from "react";
import { Box, Typography, Card, CardContent, Chip, alpha } from "@mui/material";
import { useOnBoardingContext } from "./OnBoardingContext";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { GoogleMapSearchWrapper } from "./GoogleMapSearchWrapper";
import { useTranslation } from "react-i18next";
import { messages } from "../../../locales/messages";

export const OnBoardingStep1: React.FC<{ onContinue: () => void }> = ({
  onContinue,
}) => {
  const { t } = useTranslation();
  const { selectedStore } = useOnBoardingContext();

  const handleManualEntry = () => {
    // Continue without selecting a store - user will enter everything manually
    onContinue();
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card
        elevation={0}
        sx={{
          mb: 4,
          background: "linear-gradient(135deg, #f58321 0%, #ff9b4d 100%)",
          color: "white",
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Box display="flex" alignItems="center" mb={2}>
            <LocationOnIcon sx={{ fontSize: 32, mr: 2 }} />
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "1.75rem", sm: "2.125rem" },
              }}
            >
              {t(messages.Find_Your_Store())}
            </Typography>
          </Box>
          <Typography
            variant="h6"
            sx={{
              opacity: 0.95,
              fontSize: { xs: "1rem", sm: "1.125rem" },
              fontWeight: 400,
              lineHeight: 1.6,
            }}
          >
            {t(
              messages.Search_for_your_store_and_verify_the_location_on_our_map()
            )}
          </Typography>
        </CardContent>
      </Card>

      {selectedStore && (
        <Box display="flex" justifyContent="center" mb={3}>
          {" "}
          <Chip
            icon={<CheckCircleIcon />}
            label={t(messages.Store_Selected())}
            color="success"
            variant="filled"
            sx={{
              px: 2,
              py: 1,
              fontSize: "0.875rem",
              fontWeight: 600,
              backgroundColor: alpha("#4caf50", 0.1),
              color: "#2e7d32",
              border: "1px solid",
              borderColor: alpha("#4caf50", 0.3),
              "& .MuiChip-icon": {
                color: "#2e7d32",
              },
            }}
          />
        </Box>
      )}

      <Card
        elevation={1}
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          border: "1px solid",
          borderColor: alpha("#000", 0.06),
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <GoogleMapSearchWrapper
            selectedStore={selectedStore}
            onContinue={onContinue}
            onManualEntry={handleManualEntry}
          />
        </CardContent>
      </Card>
    </Box>
  );
};
